import { Reservation } from "types/reservations";
import { ReservationShift } from "types/shifts";
import { effectiveShiftSettings } from "./dayOverrides";

type PaymentReservation = Pick<
    Reservation,
    "status" | "event" | "eventId" | "ticket"
> & {
    paymentArrivedButNoSeat?: boolean;
    wishCheckoutAuthorizationFailed?: boolean;
    tables?: string[] | null;
};

export function reservationPaymentWarning(
    reservation: PaymentReservation,
    shifts?: ReservationShift[] | null
) {
    if (reservation.wishCheckoutAuthorizationFailed) {
        return {
            kind: "review" as const,
            title: "Zahlung und Buchung prüfen",
            description:
                "Eine Zahlung oder Zahlungsmittelhinterlegung ist eingegangen, aber die Buchungsfreigabe ist nicht mehr gültig. Bitte Zahlungsbelege und Besuchswunsch prüfen."
        };
    }
    // A table assigned since the late payment ends the warning, even if the flag is stale.
    if (
        !reservation.paymentArrivedButNoSeat ||
        reservation.status === "failed" ||
        !!reservation.tables?.length
    )
        return null;
    const id =
        reservation.ticket?.eventId ||
        reservation.eventId ||
        reservation.event?.id;
    const current = id
        ? shifts
              ?.map((s) => effectiveShiftSettings(s).eventV02)
              .find((e) => e?.id === id)
        : null;
    const event = current ?? reservation.ticket?.event ?? reservation.event;
    if (event?.ignoreTables === true) return null;
    return {
        kind: "seat" as const,
        title: "Zahlung eingegangen – bitte manuell platzieren",
        description:
            "Für diese Buchung ist kein Tisch gesichert. Bitte einen freien Tisch zuweisen."
    };
}
